export default {
	careers(state) {
		return state.careers
	},
	selected_career(state) {
		return state.selected_career
	},
}
